var _path, _path2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundBottom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 915,
    height: 74,
    viewBox: "0 0 915 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M903.651 6C903.651 8.94552 906.039 11.3333 908.984 11.3333C911.93 11.3333 914.318 8.94552 914.318 6C914.318 3.05448 911.93 0.666667 908.984 0.666667C906.039 0.666667 903.651 3.05448 903.651 6ZM435.703 7H908.984V5H435.703V7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M780 6L837.891 74H0V6H780Z",
    fill: "#242E35"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 813.391,
    y1: 23,
    x2: 705.391,
    y2: 23,
    stroke: "#3ED4DC",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundBottom);
export default __webpack_public_path__ + "static/media/background-bottom.e3682015f1337a8756ba7cd75be2ebf7.svg";
export { ForwardRef as ReactComponent };